// import React, { useEffect, useState } from "react";
// import { Grid } from "@mui/material";
// import CustomTable from "../../../../Components/Table/CustomTable";
// import UserCreateByOperatorModal from "../../Modal/UserCreateByOperatorModal";
// import { useDispatch, useSelector } from "react-redux";
// import { setHeaderName } from "../../../../ReduxStore/Slices/headerSlice";
// import TableDataViewModal from "../../Modal/TableDataViewModal";
// import actions from "../../../../ReduxStore/actions";
// // import { setHeaderName } from './headerSlice';

// const TotalPurchaseForUsers = ({ setHeaderTitleName }) => {
//   const dispatch = useDispatch();
//   const tableData = [
//     {
//       Name: "Vallarasu",
//       Email: "valla@gmail.com",
//       MobileNumber: "1232343444",
//       UserType: "Individual",
//       Status: "Approved",
//     },
//     {
//       Name: "Pravin",
//       Email: "pravin@gmail.com",
//       MobileNumber: "98787687687",
//       UserType: "Individual",
//       Status: "Approved",
//     },
//     {
//       Name: "Shahul",
//       Email: "shahul@gmail.com",
//       MobileNumber: "123322443543",
//       UserType: "Individual",
//       Status: "Approved",
//     },
//     {
//       Name: "Ramesh",
//       Email: "Ramesh@gmail.com",
//       MobileNumber: "76575675664",
//       UserType: "Individual",
//       Status: "Approved",
//     },
//     {
//       Name: "Sanjeev",
//       Email: "Sanjeev@gmail.com",
//       MobileNumber: "909878789709",
//       UserType: "Financial Consultant",
//       Status: "Pending",
//     },
//   ];

//   const sessionOperator_id = sessionStorage.getItem("sessionOperator_id");
//   const UserRole = sessionStorage.getItem("UserRole");

//   useEffect(() => {
//     // setHeaderTitleName("User Registration")
//     dispatch(setHeaderName("Total Purchase users"));
//   }, []);
//   const tableHeadData = [
//     "S.No",
//     "Customer Name",
//     "Scheme Name",
//     // "Order ID",
//     "Stake Starting",
//     "Stake Maturity",
//     "Lock-In",
//     "Value",
//     "Gold Staked",
//     // "Actions",
//   ];

//   const { getPurchasesByCreator } = useSelector(
//     (state) => state?.getPurchasesByCreator
//   );

//   console.log(getPurchasesByCreator, "getPurchasesByCreator");
//   useEffect(() => {
//     const data1 = {
//       data: {
//         createdByUserId: sessionOperator_id,
//         createdByUserRole: UserRole,
//       },
//       method: "get",
//       apiName: "getPurchasesByCreator",
//     };

//     dispatch(actions.GETPURCHASESBYCREATOR(data1));
//   }, [dispatch]);

//   const [rowTableData, setRowTableData] = useState([
//     {
//       //   customer_name: "--",
//       customer_id: "--",

//       purchase_id: "--",
//       title: "--",
//       purchase_id: "--",
//       stake_starting: "--",
//       stake_maturity: "--",
//       lock_in_months: "--",
//       value_of_purchase: "--",
//       purchase_stake: "--",
//     },
//   ]);
//   console.log(rowTableData, "rowTableDatarowTableData");
//   useEffect(() => {
//     const tempArr = [];
//     getPurchasesByCreator?.data?.map((data, index) => {
//       return tempArr.push({
//         // Name: `${data?.first_name} ${data?.last_name}`,
//         // Email: data?.email,
//         // MobileNumber: data?.phone,
//         // UserType: data?.role,
//         // Status:
//         //   data?.approval_status === "pending"
//         //     ? "Pending"
//         //     : data?.approval_status === "approved"
//         //     ? "Approved"
//         //     : "Unknown", // Add a default case if needed
//         customer_id: data?.customer_id,
//         customer_name: `${data?.customer?.first_name} ${data?.customer?.last_name}`,

//         title: data?.title,
//         purchase_id: data?.purchase_id,
//         purchase_id: data?.purchase_id,
//         stake_starting: data?.stake_starting,
//         stake_maturity: data?.stake_maturity,
//         lock_in_months: `${data?.lock_in_months} Months`,
//         value_of_purchase: `${data?.value_of_purchase} USD`,
//         purchase_stake: `${data?.purchase_stake} g`,
//       });
//     });
//     setRowTableData(tempArr);
//   }, [dispatch, getPurchasesByCreator]);

//   return (
//     <Grid container spacing={2}>
//       <Grid item xs={12} sx={{ width: "100px" }}>
//         <CustomTable
//           tableData={rowTableData}
//           title="Purchase User List"
//           tableHeadData={tableHeadData}
//           rowPerPage={10}
//           tableView="tableView"
//           tableSearch="tableSearch"
//           // dataCreate="dataCreate"
//           // tableEdit="tableEdit"
//           // tableDelete="tableDelete"
//           modalName={UserCreateByOperatorModal}
//           allShowModal="allShowModal"
//           modalVeiwName={TableDataViewModal}
//           notModalTable="notModalTable"
//           modalViewHeadingName="User Detail"
//           modalHeadingName="Create User"
//         />
//       </Grid>
//     </Grid>
//   );
// };

// export default TotalPurchaseForUsers;


import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import CustomTable from "../../../../Components/Table/CustomTable";
import UserCreateByOperatorModal from "../../Modal/UserCreateByOperatorModal";
import { useDispatch, useSelector } from "react-redux";
import { setHeaderName } from "../../../../ReduxStore/Slices/headerSlice";
import TableDataViewModal from "../../Modal/TableDataViewModal";
import actions from "../../../../ReduxStore/actions";
import PurchaseApprovalModalView from "../../../Management/PurchaseApproval/Modal/PurchaseApprovalModalView";
// import { setHeaderName } from './headerSlice';

const TotalPurchaseForUsers = ({ setHeaderTitleName }) => {
  const dispatch = useDispatch();
  const tableData = [
    {
      Name: "Vallarasu",
      Email: "valla@gmail.com",
      MobileNumber: "1232343444",
      UserType: "Individual",
      Status: "Approved",
    },
    {
      Name: "Pravin",
      Email: "pravin@gmail.com",
      MobileNumber: "98787687687",
      UserType: "Individual",
      Status: "Approved",
    },
    {
      Name: "Shahul",
      Email: "shahul@gmail.com",
      MobileNumber: "123322443543",
      UserType: "Individual",
      Status: "Approved",
    },
    {
      Name: "Ramesh",
      Email: "Ramesh@gmail.com",
      MobileNumber: "76575675664",
      UserType: "Individual",
      Status: "Approved",
    },
    {
      Name: "Sanjeev",
      Email: "Sanjeev@gmail.com",
      MobileNumber: "909878789709",
      UserType: "Financial Consultant",
      Status: "Pending",
    },
  ];

  const sessionOperator_id = sessionStorage.getItem("sessionOperator_id");
  const UserRole = sessionStorage.getItem("UserRole");

  useEffect(() => {
    // setHeaderTitleName("User Registration")
    dispatch(setHeaderName("Total Purchase users"));
  }, []);
  const tableHeadData = [
    "S.No",
    "Customer Name",
    "Scheme Name",
    // "Order ID",
    "Stake Starting",
    "Stake Maturity",
    "Lock-In",
    "Value",
    "Gold Staked",
    // "Actions",
  ];

  const { getPurchasesByCreator } = useSelector(
    (state) => state?.getPurchasesByCreator
  );

  console.log(getPurchasesByCreator, "getPurchasesByCreator");
  useEffect(() => {
    const data1 = {
      data: {
        createdByUserId: sessionOperator_id,
        createdByUserRole: UserRole,
      },
      method: "get",
      apiName: "getPurchasesByCreator",
    };

    dispatch(actions.GETPURCHASESBYCREATOR(data1));
  }, [dispatch]);

  const [rowTableData, setRowTableData] = useState([
    {
      //   customer_name: "--",
      customer_id: "--",

      purchase_id: "--",
      title: "--",
      purchase_id: "--",
      stake_starting: "--",
      stake_maturity: "--",
      lock_in_months: "--",
      value_of_purchase: "--",
      purchase_stake: "--",
    },
  ]);
  console.log(rowTableData, "rowTableDatarowTableData");
  useEffect(() => {
    const tempArr = [];
    getPurchasesByCreator?.data?.map((data, index) => {
      return tempArr.push({
        // Name: `${data?.first_name} ${data?.last_name}`,
        // Email: data?.email,
        // MobileNumber: data?.phone,
        // UserType: data?.role,
        // Status:
        //   data?.approval_status === "pending"
        //     ? "Pending"
        //     : data?.approval_status === "approved"
        //     ? "Approved"
        //     : "Unknown", // Add a default case if needed
        // customer_id: data?.customer_id,
        customer_name: `${data?.customer?.first_name} ${data?.customer?.last_name}`,

        title: data?.title,
        purchase_id: data?.purchase_id,
        purchase_id: data?.purchase_id,
        stake_starting: data?.stake_starting,
        stake_maturity: data?.stake_maturity,
        lock_in_months: `${data?.lock_in_months} Months`,
        value_of_purchase: `${data?.value_of_purchase} USD`,
        purchase_stake: `${data?.purchase_stake} g`,
      });
    });
    setRowTableData(tempArr);
  }, [dispatch, getPurchasesByCreator]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sx={{ width: "100px" }}>
        <CustomTable
          tableData={rowTableData}
          title="Purchase User List"
          tableHeadData={tableHeadData}
          rowPerPage={10}
          tableView="tableView"
          tableSearch="tableSearch"
          // dataCreate="dataCreate"
          // tableEdit="tableEdit"
          // tableDelete="tableDelete"
          modalName={UserCreateByOperatorModal}
          // allShowModal="allShowModal"
          modalVeiwName={PurchaseApprovalModalView}
          notModalTable="notModalTable"
          modalViewHeadingName="User Detail"
          modalHeadingName="Create User"
        />
      </Grid>
    </Grid>
  );
};

export default TotalPurchaseForUsers;
